import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganization } from "./useOrganization";

export interface RewardConfig {
  id: string;
  organization_id: string;
  is_enabled: boolean;
  coins_per_booking: number;
  coins_per_match: number;
  coins_per_tournament: number;
}

export function useRewardConfig() {
  const { organization } = useOrganization();

  const { data: config, ...rest } = useQuery({
    queryKey: ["reward-config", organization?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("reward_config" as any)
        .select("*")
        .eq("organization_id", organization!.id)
        .maybeSingle();
      if (error) throw error;
      return data as unknown as RewardConfig | null;
    },
    enabled: !!organization?.id,
  });

  // PR-AY1 (bug fix from strictNullChecks deep-dive §1.3): the original
  // `{ config, isEnabled: ..., ...rest }` was silently overwritten by `...rest`
  // because react-query v5's result includes its own `isEnabled` mirror of
  // the `enabled` option. Result: callers received `!!organization?.id`
  // (whether the QUERY was enabled) instead of `config?.is_enabled` (whether
  // REWARDS are admin-enabled). The "soft kill switch" config field was
  // effectively useless. Reorder: spread first, our explicit field wins.
  return { ...rest, config, isEnabled: config?.is_enabled ?? false };
}
